export default __webpack_public_path__ + "static/media/ic_faroe_islands.655a76e3.svg";